import { z } from "zod";

export const OrganizationPathParamsSchema = z.object({
    organizationId: z.string().uuid(),
});

export const WorkspacePathParamsSchema = z.object({
    workspaceId: z.string().uuid(),
});

export const ServicePathParamsSchema = z.object({
    serviceId: z.string().uuid(),
});

export const OrganizationServiceCreateSchema = z.object({
    name: z.string().trim().min(1, { message: "Required" }).max(255),
});

export type OrganizationServiceCreate = z.infer<
    typeof OrganizationServiceCreateSchema
>;

export const OrganizationServiceUpdateSchema = z.object({
    name: z.string().trim().min(1).max(255),
});

export type OrganizationServiceUpdate = z.infer<
    typeof OrganizationServiceUpdateSchema
>;
